import Swiper, { Navigation, Autoplay } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';
import { setActiveProcessCard } from '../cards/process.component.js';

function debounce(fn, delay = 150) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), delay);
  };
}

let processSwiperWr = document.querySelectorAll('.process-swiper-wr');
processSwiperWr.forEach((el) => {
  if (!el) return;

  let swiperEl = el.querySelector('.swiper');
  let nextEl = el.querySelector('.swiper-button-next');
  let prevEl = el.querySelector('.swiper-button-prev');

  if (!swiperEl) return;

  const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
  let lockFrame = null;
  let swiper = null;

  function resetSlidesHeight() {
    slides.forEach((s) => (s.style.height = ''));
    swiperEl.style.minHeight = '';
  }

  function updateContentMaxHeights() {
    slides.forEach((slide) => {
      const content = slide.querySelector('.process-card__content');
      if (!content) return;

      content.style.setProperty('--process-card-content-max', `${Math.ceil(content.scrollHeight)}px`);
    });
  }

  function measureMaxOpenHeight() {
    const noTransStyle = document.createElement('style');
    noTransStyle.textContent =
      '.process-card, .process-card__head, .process-card__content { transition: none !important; }';
    document.head.appendChild(noTransStyle);

    let maxH = 0;
    slides.forEach((slide) => {
      const card = slide.querySelector('.process-card');
      if (!card) return;
      const wasActive = card.classList.contains('is-active');
      if (!wasActive) card.classList.add('is-active');
      void slide.offsetHeight;
      maxH = Math.max(maxH, slide.offsetHeight);
      if (!wasActive) card.classList.remove('is-active');
    });

    requestAnimationFrame(() => document.head.removeChild(noTransStyle));
    return maxH;
  }

  function lockSlidesHeight() {
    resetSlidesHeight();
    updateContentMaxHeights();

    const maxH = measureMaxOpenHeight();

    if (maxH > 0) {
      slides.forEach((s) => (s.style.height = maxH + 'px'));
      swiperEl.style.minHeight = maxH + 'px';
    }

    swiper?.update();
  }

  function scheduleLockSlidesHeight() {
    if (lockFrame) {
      cancelAnimationFrame(lockFrame);
    }

    lockFrame = requestAnimationFrame(() => {
      lockFrame = null;
      lockSlidesHeight();
    });
  }

  function isMobile() {
    return window.innerWidth <= 640;
  }

  swiper = new Swiper(swiperEl, {
    modules: [Navigation, Autoplay],
    observer: true,
    observeParents: true,
    spaceBetween: 16,
    slidesPerView: 1,
    speed: 500,
    threshold: 10,
    navigation: {
      nextEl,
      prevEl,
    },
    breakpoints: {
      641: {
        spaceBetween: 16,
        slidesPerView: 2,
      },
      961: {
        spaceBetween: 16,
        slidesPerView: 3,
      },
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: window.innerWidth >= 1033,
    },
    on: {
      afterInit() {
        scheduleLockSlidesHeight();
      },
      breakpoint() {
        resetSlidesHeight();
        scheduleLockSlidesHeight();
      },
      slideChange() {
        if (!isMobile()) return;
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeCard = activeSlide?.querySelector('.process-card');
        if (activeCard) setActiveProcessCard(activeCard);
      },
    },
  });

  window.addEventListener(
    'resize',
    debounce(() => {
      resetSlidesHeight();
      scheduleLockSlidesHeight();
    }, 200)
  );

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleLockSlidesHeight).catch(scheduleLockSlidesHeight);
  }

  window.addEventListener('load', scheduleLockSlidesHeight, { once: true });

  swiperObserver(swiper);
});
